export default "__VITE_ASSET__BINmX$BN__"